import {Dashboard} from "../types/stats";
import {jsonToMap} from "../../../common/utils/MapConverter";

export function convertDashboard(json: Record<string, any>) : Dashboard {
    return {
        lessons: json.lessons,
        reviews: json.reviews,
        reviewForecast: json.reviewForecast,
        srsStages: jsonToMap(json.srsStages, k => Number(k)),
        srsStageProgress: jsonToMap(json.srsStageProgress, k => Number(k), v => jsonToMap(v, k2 => Number(k2))),
        lessonHistory: jsonToMap(json.lessonHistory, k => new Date(k)),
        stats: {
            allWordsCount: json.stats.allWordsCount,
            learnedWordsCount: json.stats.learnedWordsCount,
            learnedWordsLastWeekCount: json.stats.learnedWordsLastWeekCount,
            completedReviewsCount: json.stats.completedReviewsCount,
            completedReviewsLastWeekCount: json.stats.completedReviewsLastWeekCount,
            currentStreak: json.stats.currentStreak,
            longestStreak: json.stats.longestStreak,
            activityToday: json.stats.activityToday,
            firstDate: new Date(json.stats.firstDate)
        },
        recentLessons: json.recentLessons,
        upcomingLessons: json.upcomingLessons,
        recentMistakes: json.recentMistakes,
        topMistakes: json.topMistakes
    };
}